import './index.css';
import './variables.css';
import './i18n';
import './services/dataDog';

import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';

import { App } from './app/App';
import { isGuruPayAppSession } from './utils/utils';

if (import.meta.env.VITE_GTM_ID && !isGuruPayAppSession()) {
	const tagManagerArgs = {
		gtmId: import.meta.env.VITE_GTM_ID || '',
	};

	TagManager.initialize(tagManagerArgs);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
